import { Component } from '@chialab/synapse/src/component.js';
import { mix, on, off, Symbolic } from '@chialab/proteins';

const LISTENERS_SYM = Symbolic('listeners');

export const DockBookingComponentMixin = (SuperClass) => class extends SuperClass {
    get lang() {
        const locale = this.factory('locale');
        return locale ? locale.currentLang : 'en';
    }

    /**
     * @inheritdoc
     */
    constructor(...args) {
        super(...args);
        if (!this[LISTENERS_SYM]) {
            this[LISTENERS_SYM] = [];
        }
    }

    /**
     * @inheritdoc
     */
    async initialize(...args) {
        await super.initialize(...args);
        const locale = this.factory('locale');
        if (locale) {
            this.listen(locale, 'change', () => this.template && this.render());
        }
        return this;
    }

    /**
     * Translate input string.
     *
     * @param {string} str The string to translate.
     * @return {string} translated string
     */
    translate(str, ...args) {
        const locale = this.factory('locale');
        if (!locale) {
            //eslint-disable-next-line
            console.warn('Cannot find locale factory, input string returned');
            return str;
        }
        return locale.translate(str, ...args);
    }

    /**
     * Add a listener for a specific event on an emitter.
     * @param {object} emitter The emitter.
     * @param {string} event The event name.
     * @param {Function} callback The callback for the event.
     * @return {Function} The destroyer function for the listener.
     */
    listen(emitter, event, callback) {
        let destroyer = on(emitter, event, callback);
        this[LISTENERS_SYM].push(destroyer);
        return destroyer;
    }

    /**
     * Remove a listener for a specific event on an emitter.
     * @param {object} [emitter] The emitter.
     * @param {string} [event] The event name.
     * @param {Function} [callback] The callback for the event.
     * @return {void}
     */
    unlisten(emitter, event, callback) {
        if (emitter) {
            off(emitter, event, callback);
        } else {
            this[LISTENERS_SYM].forEach((offListener) => offListener());
            this[LISTENERS_SYM] = [];
        }
    }

    /**
     * @inheritdoc
     */
    destroy() {
        this.unlisten();
        return super.destroy ? super.destroy() : Promise.resolve();
    }
};

/**
 * Base Component for the Dockbooking CDK.
 */
export default class BaseComponent extends mix(Component).with(DockBookingComponentMixin) {}
